import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"

const UpdateVoucherForm = () => {
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const [formData, setFormData] = useState({
      book: "",
      page: "",
      public_id: "",
      year: "",
      month: ""
  })
  const {book, page, year, month, public_id} = formData

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {

    if (location.state){
        const {payload} = location.state
        setFormData({
            year: payload.year,
            month: payload.month,
            book: payload.book,
            page: payload.page,
            public_id: payload.public_id
        })
    }

  }, [location]);
  

  const onChange = (e) => {
      setFormData((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value
      }))
  }

  const onSubmit = (e) => {
      e.preventDefault()
      
      updateVoucher({book, page})
  }
  
  // update voucher
  const updateVoucher = async (payload) => {
      setIsLoading(true)
      try {
          const response = await Server.put(`/vouchers/${public_id}`, payload);
          setIsLoading(false)
          toast.success(response.data.detail);
          navigate(`/monthly-voucher-detail`, { state: {payload: {
            year: year,
            month: month,
            book: book
          }}})
      } catch (error) {
          setIsLoading(false)
          if(error.response.status === 401){
              navigate('/login')
          }else if (error.response.status === 422){
            setErrors({})
            error.response?.data?.detail.map((err) => (
                setErrors((prevState) => ({
                    ...prevState,
                    [err.loc[1]]: err.msg
                }))
            ))
        }else if (error.response.status === 403){
              toast.error(error.response.data.detail);
              navigate('/');
          }else {
            toast.error(error.response.data.detail);
        }
      }
  }

  if(isLoading){
      return <Spinner/>
  }


return (
  <>
    <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Update Voucher Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <InputField
                                name="book"
                                type="text"
                                label="Book"
                                value={book}
                                onChange={onChange}
                                error={errors.book}
                            />
                        </div>
                        <div className="col-md-6">
                            <InputField
                                name="page"
                                type="text"
                                label="Page"
                                value={page}
                                onChange={onChange}
                                error={errors.page}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Update Voucher" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
  </>
)
}

export default UpdateVoucherForm
